import __vue_component__$a from './TdlOverlay.js';
import __vue_component__$1 from './MdButton.js';
import __vue_component__$2 from './MdDialog.js';
import __vue_component__$3 from './MdDialogActions.js';
import __vue_component__$4 from './MdDialogContent.js';
import __vue_component__$5 from './MdDialogTitle.js';
import __vue_component__$6 from './MdIcon.js';
import __vue_component__$7 from './MdToolbar.js';
import __vue_component__$8 from './MdSpinner.js';
import __vue_component__$9 from './MdWhiteframe.js';
import { a as applyPassive } from './events-250f1987.js';
import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import { c as createInjector } from './browser-ac904bdc.js';
import './MdInkRipple.js';
import './transitionEndEventName-a2ae6d4b.js';
import './MdBackdrop.js';

const TdlFullscreendialog = {
  name: "tdl-fullscreendialog",
  components: {
    MdButton: __vue_component__$1,
    MdDialog: __vue_component__$2,
    MdDialogActions: __vue_component__$3,
    MdDialogContent: __vue_component__$4,
    MdDialogTitle: __vue_component__$5,
    MdIcon: __vue_component__$6,
    MdToolbar: __vue_component__$7,
    MdSpinner: __vue_component__$8,
    MdWhiteframe: __vue_component__$9,
    TdlOverlay: __vue_component__$a
  },
  props: {
    dialogAlias: {
      type: String,
      required: false
    },
    dialogOkText: {
      type: String,
      required: false
    },
    dialogCancelText: {
      type: String,
      required: false
    },
    dialogTitle: {
      type: String,
      required: false
    },
    dialogSubtitle: {
      type: String,
      required: false
    },
    dialogSubmitButton: {
      type: String,
      required: false,
      default: "visible",
      validator: val => ["disabled", "hidden", "visible", "fake-disabled"].includes(val)
    },
    dialogContentBackground: {
      type: String,
      required: false
    },
    dialogShutdownTransition: {
      type: Boolean,
      required: false,
      default: true
    },
    dialogProgressBar: {
      type: Boolean,
      default: false
    },
    dialogProcessing: {
      type: Boolean,
      default: false
    },
    desktopFullScreen: {
      type: Boolean,
      default: false
    },
    plainView: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    allowDialogActionsInMobile: {
      type: Boolean,
      default: false
    },
    alwaysClose: {
      type: Boolean,
      default: false
    },
    allowGoBack: {
      type: Boolean,
      default: false
    },
    shouldCloseDialogAfterConfirmation: {
      type: Function,
      default: () => true
    },
    outsideClosable: {
      type: Boolean,
      default: true
    },
    visibleOnLoad: {
      type: Boolean,
      default: false
    },
    showTitleDividerLine: {
      type: Boolean,
      default: true
    },
    showActionDividerLine: {
      type: Boolean,
      default: true
    },
    mdHideOverflow: {
      type: Boolean,
      default: true
    },
    closeBeforeDestroy: {
      type: Boolean,
      default: true
    },
    escapeClosable: {
      type: Boolean,
      default: true
    },
    shouldShowHelpSupportButton: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      opened: false,
      contentHeight: 0,
      currentDialogContent: null,
      mdiArrowLeftIcon: null,
      mdiCloseIcon: null,
      mdiHelpCircleIcon: null
    };
  },
  computed: {
    cancellable: function () {
      return !!this.dialogCancelText;
    },
    showProgressBar: function () {
      return this.dialogProcessing || this.dialogProgressBar;
    },
    closeDialogIcon: function () {
      return this.allowGoBack ? this.mdiArrowLeftIcon : this.mdiCloseIcon;
    }
  },
  async created() {
    const {
      mdiArrowLeft,
      mdiClose,
      mdiHelpCircle
    } = await import('./mdiImports-f5901505.js');
    this.mdiArrowLeftIcon = mdiArrowLeft;
    this.mdiCloseIcon = mdiClose;
    this.mdiHelpCircleIcon = mdiHelpCircle;
  },
  mounted() {
    if (this.visibleOnLoad) {
      this.open();
    }
  },
  methods: {
    buttonClicked: function () {
      if (this.dialogSubmitButton === "disabled") {
        this.$emit("disabled-clicked");
      }
    },
    openDialog: function () {
      this.$refs.dialog.open();
    },
    closeDialog: function () {
      this.$refs.dialog.close();
    },
    cancelDialog: function () {
      this.$emit("cancel");
      if (this.alwaysClose) {
        this.closeDialog();
      }
    },
    actionDialog: function () {
      this.$emit("ok");
    },
    open: function () {
      this.opened = true;
      this.$emit("on-open");
      this.$root.$emit("help-fab::display", false);
      this.logScroll();
    },
    logScroll: function () {
      this.currentDialogContent = this.$refs.dialogContent.$el;
      this.contentHeight = this.currentDialogContent.scrollHeight - this.currentDialogContent.offsetHeight;
      this.currentDialogContent.addEventListener("scroll", this.onScrollContent, applyPassive());
    },
    onScrollContent: function () {
      if (this.contentHeight <= this.currentDialogContent.scrollTop) {
        this.$emit("end-reached");
        this.stopLogScroll();
      }
    },
    close: function () {
      this.opened = false;
      this.$emit("on-close");
      this.stopLogScroll();
      setTimeout(() => {
        this.$root.$emit("help-fab::display", true);
      }, 200);
    },
    stopLogScroll: function () {
      this.currentDialogContent.removeEventListener("scroll", this.onScrollContent, applyPassive());
    },
    handleHelpFabClick: function () {
      this.$root.$emit("help-fab::open");
    }
  }
};

const __vue_script__ = TdlFullscreendialog;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('md-dialog', {
    ref: "dialog",
    class: ['tdl-full-screen-dialog', {
      'plain-view': _vm.plainView
    }, {
      'desktop-full-screen': _vm.desktopFullScreen
    }],
    attrs: {
      "md-shutdown-transition": _vm.dialogShutdownTransition,
      "md-click-outside-to-close": !_vm.dialogProcessing && _vm.closable && _vm.outsideClosable,
      "md-esc-to-close": !_vm.dialogProcessing && _vm.closable && _vm.escapeClosable,
      "should-close-dialog-after-confirmation": _vm.shouldCloseDialogAfterConfirmation,
      "visible-on-load": _vm.visibleOnLoad,
      "md-hide-overflow": _vm.mdHideOverflow,
      "close-before-destroy": _vm.closeBeforeDestroy
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "banner",
      fn: function () {
        return [_vm._t("banner")];
      },
      proxy: true
    }], null, true)
  }, [_vm.dialogProcessing ? _c('div', {
    staticClass: "dialog-overlay"
  }) : _vm._e(), _vm._v(" "), _c('md-whiteframe', {
    staticClass: "md-large",
    attrs: {
      "md-elevation": "1"
    }
  }, [_c('md-toolbar', {
    staticClass: "top-actions-toolbar"
  }, [_vm.closable ? _c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function ($event) {
        return _vm.cancelDialog();
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "icon-svg": _vm.closeDialogIcon
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-titles"
  }, [_vm.dialogSubtitle ? _c('p', {
    staticClass: "md-caption modal-title-text"
  }, [_vm._v("\n          " + _vm._s(_vm.dialogSubtitle) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm.dialogTitle ? _c('p', {
    staticClass: "md-title modal-title-text"
  }, [_vm._v("\n          " + _vm._s(_vm.dialogTitle) + "\n        ")]) : _vm._e()]), _vm._v(" "), _vm.shouldShowHelpSupportButton ? _c('md-button', {
    staticClass: "md-icon-button help-btn",
    nativeOn: {
      "click": function ($event) {
        return _vm.handleHelpFabClick();
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "icon-svg": _vm.mdiHelpCircleIcon
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._t("extra-actions"), _vm._v(" "), _vm._t("toolbar-actions", function () {
    return [_c('md-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.dialogSubmitButton !== 'hidden',
        expression: "dialogSubmitButton !== 'hidden'"
      }],
      class: ['md-primary md-raised top-action', {
        'md-fake-disabled': _vm.dialogSubmitButton === 'fake-disabled'
      }],
      attrs: {
        "disabled": _vm.dialogSubmitButton === 'disabled'
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.actionDialog();
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.dialogOkText) + "\n        ")])];
  })], 2)], 1), _vm._v(" "), _c('md-dialog-title', {
    class: ['md-caption modal-title', {
      'show-title-divider-line': _vm.showTitleDividerLine
    }]
  }, [_c('div', {
    staticClass: "modal-title-group",
    class: {
      'plain-view': _vm.plainView
    }
  }, [_vm.closable && _vm.allowGoBack ? _c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function ($event) {
        return _vm.cancelDialog();
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "icon-svg": _vm.mdiArrowLeftIcon
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-titles"
  }, [_vm.dialogSubtitle ? _c('p', {
    staticClass: "md-caption dialog-subtitle"
  }, [_vm._v("\n          " + _vm._s(_vm.dialogSubtitle) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm.dialogTitle ? _c('p', [_vm._v("\n          " + _vm._s(_vm.dialogTitle) + "\n        ")]) : _vm._e()]), _vm._v(" "), _vm.shouldShowHelpSupportButton ? _c('md-button', {
    staticClass: "md-icon-button help-btn",
    nativeOn: {
      "click": function ($event) {
        return _vm.handleHelpFabClick();
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "icon-svg": _vm.mdiHelpCircleIcon
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-title__extra-actions"
  }, [_vm._t("extra-actions")], 2), _vm._v(" "), _vm.closable && !_vm.allowGoBack ? _c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function ($event) {
        return _vm.cancelDialog();
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "icon-svg": _vm.mdiCloseIcon
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _vm._t("title-extra")], 2), _vm._v(" "), _c('md-dialog-content', {
    ref: "dialogContent",
    style: {
      'background': _vm.dialogContentBackground
    }
  }, [_vm._t("default"), _vm._v(" "), _vm.showProgressBar ? _c('tdl-overlay', [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e()], 2), _vm._v(" "), _vm.dialogCancelText || _vm.$slots['dialog-actions'] || _vm.dialogOkText ? _c('md-dialog-actions', {
    class: {
      'always-visible': _vm.allowDialogActionsInMobile,
      'show-action-divider-line': _vm.showActionDividerLine
    }
  }, [_c('div', {
    class: [_vm.dialogCancelText ? 'has-cancel-button' : '', 'md-dialog-actions__group'],
    on: {
      "click": function ($event) {
        return _vm.buttonClicked();
      }
    }
  }, [_vm.cancellable ? _c('md-button', {
    staticClass: "md-error",
    nativeOn: {
      "click": function ($event) {
        return _vm.cancelDialog();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.dialogCancelText) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm._t("dialog-actions", function () {
    return [_c('md-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.dialogSubmitButton !== 'hidden',
        expression: "dialogSubmitButton !== 'hidden'"
      }],
      class: ['md-primary md-raised dialog-actions-done', {
        'md-fake-disabled': _vm.dialogSubmitButton === 'fake-disabled'
      }],
      attrs: {
        "disabled": _vm.dialogSubmitButton === 'disabled'
      },
      nativeOn: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.actionDialog();
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.dialogOkText) + "\n        ")])];
  })], 2)]) : _vm._e()], 1);
};
var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-c00ec58c_0", {
    source: ".tdl-full-screen-dialog .md-icon-button{color:rgba(255,255,255,.65)}.tdl-full-screen-dialog .md-dialog-title{border-bottom:none!important}.tdl-full-screen-dialog .md-dialog-title .dialog-titles{color:rgba(255,255,255,.9)}.tdl-full-screen-dialog .md-dialog{max-width:680px;width:100%;overflow-y:visible;overflow-x:hidden;max-height:85%}.tdl-full-screen-dialog .md-dialog ::-webkit-scrollbar{-webkit-appearance:none;width:6px}.tdl-full-screen-dialog .md-dialog ::-webkit-scrollbar-thumb{border-radius:6px}.tdl-full-screen-dialog .top-actions-toolbar{display:none}.tdl-full-screen-dialog .top-actions-toolbar+.md-progress{display:none}.tdl-full-screen-dialog .top-actions-toolbar .top-action{flex-shrink:0}.tdl-full-screen-dialog.desktop-full-screen .md-dialog{max-width:100%;max-height:100%;width:100%;height:100%;position:absolute}.tdl-full-screen-dialog.plain-view .md-dialog-title{border-bottom:0;margin-bottom:0}.tdl-full-screen-dialog .dialog-titles{display:flex;flex-direction:column;justify-content:space-between;flex-grow:1;overflow:hidden}.tdl-full-screen-dialog .dialog-titles .dialog-subtitle{margin-bottom:4px}.tdl-full-screen-dialog .modal-title-group{display:flex;justify-content:space-between;align-items:center}.tdl-full-screen-dialog .modal-title-group .md-icon-button{display:none}@media (min-width:660px){.tdl-full-screen-dialog .modal-title-group.plain-view .md-icon-button{display:block;margin:0;padding:0}.tdl-full-screen-dialog .modal-title-group.plain-view .md-button:first-child{margin-left:0;margin-right:16px}}.tdl-full-screen-dialog .md-dialog-content{padding:8px;padding-bottom:24px;min-height:88px}.tdl-full-screen-dialog .md-dialog-content .md-input{font-size:16px}.tdl-full-screen-dialog .dialog-overlay{position:fixed;top:0;bottom:0;left:0;right:0;z-index:100}.tdl-full-screen-dialog .modal-title{border-color:rgba(255,255,255,.12)!important;color:rgba(255,255,255,.9);display:block;font-weight:600;margin-bottom:0;padding:14px 16px 14px 16px;border-bottom:0;position:relative}.tdl-full-screen-dialog .modal-title.show-title-divider-line{border-bottom:1px solid}.tdl-full-screen-dialog .modal-title .md-progress{position:absolute;bottom:0;left:0;z-index:101}.tdl-full-screen-dialog .modal-title__extra-actions{margin-top:-16px}.tdl-full-screen-dialog .md-dialog-actions{z-index:9}.tdl-full-screen-dialog .md-dialog-actions::before{height:0;background-color:rgba(255,255,255,.12)}.tdl-full-screen-dialog .md-dialog-actions__group{width:100%;display:flex;align-items:center;justify-content:flex-end}.tdl-full-screen-dialog .md-dialog-actions .has-cancel-button{justify-content:space-between}.tdl-full-screen-dialog .md-dialog-actions .has-cancel-button .md-error{color:#cf6679}.tdl-full-screen-dialog .md-dialog-actions.show-action-divider-line::before{height:1px}@media (max-width:720px){.tdl-full-screen-dialog .dialog-overlay+.md-whiteframe{z-index:unset}.tdl-full-screen-dialog .md-dialog{position:absolute;max-width:100%;max-height:100%;top:0;left:0;width:100%;height:100%}.tdl-full-screen-dialog .md-dialog .modal-title{display:none}.tdl-full-screen-dialog .md-dialog .md-dialog-actions:not(.always-visible){display:none}.tdl-full-screen-dialog .dialog-actions-done{display:none}.tdl-full-screen-dialog .md-toolbar .md-title{font-weight:400;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;margin-left:8px;margin-right:18px}.tdl-full-screen-dialog .top-actions-toolbar{display:flex;flex-wrap:nowrap;align-items:center}.tdl-full-screen-dialog .top-actions-toolbar+.md-progress{display:block;z-index:101}}.tdl-full-screen-dialog .help-btn{margin-right:8px}",
    map: undefined,
    media: undefined
  });
};
const __vue_scope_id__ = undefined;
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = false;
const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

export { __vue_component__ as default };
